<div class="row mb-3" style="margin-top:65px">
  <div class="col-12">
    <a [routerLink]="'/hourglass/tools'">
      <i class="fas fa-fw fa-lock me-2"></i>Admin Tools<i class="fas fa-fw fa-chevron-right mx-2"></i>
    </a>
    <i class="fas fa-fw fa-object-group me-2"></i>Task Combinator
  </div>
</div>
<div class="row mb-3">
  <div class="col-12 col-md-4">
    <div class="card">
      <div class="card-header bg_greendk c_white p-2">
          <i class="fas fa-fw fa-bullseye me-2"></i>Target Task: {{targetTask.taskName}}
      </div>
      <div class="card-body bg_green p-2" id="body_target">
        <div class="row mb-2">
          <div class="col-12">
            <ng-multiselect-dropdown [placeholder]="'Choose Client Group'"
                                      [settings]="clientSettings"
                                      [data]="filteredClients"
                                      [(ngModel)]="editorForm.clientFilter"
                                      (onSelect)="filterTargets($event,'filter')"
                                      (onDeSelect)="filterTargets($event,'clear')">
            </ng-multiselect-dropdown>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <ng-multiselect-dropdown [placeholder]="'Choose Target Task'"
                                      [settings]="dropdownSettings"
                                      [data]="filteredTargets"
                                      [(ngModel)]="editorForm.targetTask"
                                      (onSelect)="onItemSelect($event,'filter')"
                                      (onDeSelect)="onItemSelect($event,'clear')"
                                      (onFilterChange)="onTaskFilterChange($event)"


                                     >
            </ng-multiselect-dropdown>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12">
            <div class="my-1"><strong>ID:</strong> {{targetTask.taskID}}</div>
            <div class="my-1" *ngIf="targetTask.taskDesc != ''"><strong>Description:</strong> {{targetTask.taskDesc}}</div>
            <div class="my-1"><strong>Category:</strong> {{targetTask.categoryName}}</div>
            <div class="my-1"><strong>Client(s):</strong> {{targetTask.clientNames}}</div>
            <div class="my-1"><strong>Assignee(s):</strong> {{targetTask.assigneeNames}}</div>
            <div class="my-1"><strong>Time Entries:</strong> {{entryCount}}</div>
            <div class="my-1"><strong>Last Entry:</strong> {{targetTask.lastEntry}}</div>

            <div class="mt-4">
              <div class="card mb-0">
                <div class="card-header bg_greendk c_white">
                  <i class="fas fa-fw fa-exclamation-triangle me-2"></i>Instructions
                </div>
                <div class="card-body bg_white">
                  <ol class="mb-0">
                    <li>Choose a Client Group to limit the Target Task menu</li>
                    <li>Choose a Target Task to merge other tasks into</li>
                    <li>Pick tasks from Eligible Merge Task(s)</li>
                    <li>Use the Swap Target button to swap a Merge Task with the Target Task</li>
                    <li>Verify details in the Merged Task pane and click Save</li>
                    <li>Click Clear button to reset the form</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-4">
    <div class="card mb-0 border">
      <div class="card-header c_white" style="background:#666 !important">
        <i class="fas fa-fw fa-object-group me-2"></i>Eligible Merge Tasks
      </div>
      <div class="card-body" id="body_eligible">
        <div class="row">
          <div class="col-12">
            <input id="mergeSearch" type="text" class="form-control form-control-sm bg_white" [(ngModel)]="taskSearch"
                   placeholder="Search" (input)="searchTasks($event)" [disabled]="editorForm.targetTask == null" />
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-12">
            <div class="row mb-2">
              <div class="col-12 col-md-8">
                <label class="me-2" style="font-weight:500 !important">Task Name (Client) - Task ID: Last Entry Date</label>
              </div>
              <div class="col-12 col-md-4 text-end">
                <label class="c_green me-2" style="font-weight:600 !important">Active</label>
                <label class="c_red" style="font-weight:600 !important">Inactive</label>
              </div>
              

            </div>
            <div class="rounded border bg_white p-2" style="height:38vh;overflow-y:auto;border-color:#ccc !important">
              <div *ngFor="let t of filteredSearchedTasks" class="form-check">
                <input class="form-check-input"
                        type="checkbox"
                        [id]="'t_' + t.id"
                        (change)="onTaskToggle(t.id, $event)"
                        [disabled]="(editorForm.targetTask == '')" />
                <label class="form-check-label" [for]="'t_' + t.id" [ngClass]="(t.active_flag == 1) ? 'c_green' : 'c_red'">
                  {{ t.t_name }} - {{t.id}}: {{formatDate(t.last_entry)}}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-4">
    <div class="card">
      <div class="card-header bg_blue c_white">
        <i class="fas fa-fw fa-check-square me-2"></i>Merged Task: {{targetTask.taskName}}
      </div>
      <div class="card-body bg_bluelt p-2" id="body_merged">
        <div class="my-1"><strong>ID:</strong> {{targetTask.taskID}}</div>
        <div class="my-1" *ngIf="targetTask.taskDesc != ''"><strong>Description:</strong> {{targetTask.taskDesc}}</div>
        <div class="my-1"><strong>Category:</strong> {{targetTask.categoryName}}</div>
        <div class="my-1"><strong>Client(s):</strong> {{targetTask.clientNames}}</div>
        <div class="my-1"><strong>Assignee(s):</strong> {{uniqueAssigneesNames}}</div>
        <div class="my-1"><strong>Time Entries:</strong> {{totalCount}}</div>
        <div class="my-1"><strong>Last Entry:</strong> {{maxTimeEntry}}</div>
        <div class="mt-3">
          <app-sql-monitor></app-sql-monitor>
        </div>
        <div class="my-3 text-center">
          <button type="button" class="btn btn-lg btn-primary me-2" (click)="saveMerge()">
            <i class="fas fa-fw fa-save me-2"></i>Save
          </button>
          <button type="button" class="btn btn-lg btn-primary" (click)="clearMerge()">
            <i class="fas fa-fw fa-refresh me-2"></i>Clear
          </button>
        </div>

      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-12 col-md-4" *ngFor="let t of mergeTasks">
    <div class="card bg_light mb-2">
      <div class="card-header bg_orange c_white">
        <div class="row">
          <div class="col-9">
            <i class="fas fa-fw fa-object-group me-2"></i>Merge Task: {{t}}
          </div>
          <div class="col-3 text-end">
            <span class="fas fa-fw fa-refresh ms-3 p-1 pointer" title="Swap Target" (click)="swapTarget(t)"></span>
          </div>
        </div>
      </div>
      <div class="card-body bg_white p-2" style="border:solid 1px var(--welaraorange)">
        <div [innerHTML]="getTaskDetail(t)"></div>
      </div>
    </div>
  </div>
</div>
<div class="row mb-2" *ngIf="errorMsg != ''">
  <div class="col-12">
    <div class="alert alert-danger text-center">
      {{errorMsg}}
    </div>
  </div>
</div>
<div class="loader_mask" *ngIf="isLoading">
  <div class="loader">
    <i class="fas fa-fw fa-spinner fa-spin me-2"></i>Loading...
  </div>
</div>

